import { ThemeProvider } from "@emotion/react";
import { Box, Paper, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/default/CustomButton";
import Form from "../components/Form";
import Theme from "../utils/theme";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import { useCallback, useMemo } from "react";

const Login = () => {
    const themeState = useSelector((state: RootState) => state.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);
    const navigate = useNavigate();

    const buttonNavigate = useCallback(
        (route: string) => {
            navigate(route);
        },
        [navigate]
    );

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    minHeight: "100dvh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "linear-gradient(to right, #f5f7fa, #c3cfe2)", // subtle gradient
                }}
            >
                <Paper
                    elevation={3}
                    sx={{
                        height: { xs: "100dvh", sm: "auto" },
                        width: { xs: "100vw", sm: "100%", md: "100%" },
                        maxWidth: 420,
                        p: 5,
                        borderRadius: 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 3,
                    }}
                >
                    {/* Logo and Heading */}
                    <Box sx={{ textAlign: "center", mb: 3 }}>
                        <Box component="img" src="/images/coocoo.png" alt="CooCoo Logo" sx={{ width: 80 }} />
                        <Typography variant="h5" fontWeight="bold">
                            Log In
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Please enter your credentials.
                        </Typography>
                    </Box>

                    {/* Login Form */}
                    <Box sx={{ width: "100%", mb: 8 }}>
                        <Form method="login" route="/auth/login/" />
                    </Box>

                    {/* Guest and Register Options */}
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
                        <Box sx={{ display: "flex" }}>
                            <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
                                Don't have an account?
                            </Typography>
                            <Typography variant="body2" color="text.secondary" component="a" sx={{ cursor: "pointer" }} href="/register">
                                Register
                            </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: 2 }}>
                            <CustomButton
                                variant="outlined"
                                label="Continue as Guest"
                                type="button"
                                onClick={() => buttonNavigate("/")}
                                sx={{ fontSize: "0.75rem", px: 2, color: "white" }}
                            />
                        </Box>
                    </Box>
                </Paper>
            </Box>
        </ThemeProvider>
    );
};

export default Login;
